import apiClient from './apiClient';

export const s3Api = {
	// Upload a file with optional path
	upload: async (orgId, file, path = '') => {
		const formData = new FormData();
		formData.append('file', file);

		// Special case for new organizations
		const uploadUrl =
			orgId === 'new' ? `/api/uploads/new` : `/api/uploads/${orgId}`;

		const response = await apiClient.post(
			`${uploadUrl}?path=${encodeURIComponent(path)}`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
		return response.data.fileUrl;
	},

	// Upload user avatar
	uploadAvatar: async (orgId, userId, file) => {
		const formData = new FormData();
		formData.append('file', file);

		const response = await apiClient.post(
			`/api/uploads/${orgId}/avatars/${userId}`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		);
		return response.data.fileUrl;
	},

	// Delete a file
	deleteFile: async (orgId, filePath) => {
		await apiClient.delete(`/api/uploads/${orgId}/${filePath}`);
	},

	// Get signed URL for a file
	getSignedUrl: async (key) => {
		const response = await apiClient.get(
			`/api/uploads/signed-url?key=${encodeURIComponent(key)}`
		);
		return response.data.signedUrl;
	},

	// Move a file
	moveFile: async (orgId, sourceUrl, newFolderId, fileName) => {
		const response = await apiClient.post(`/api/uploads/${orgId}/move`, {
			sourceUrl,
			newFolderId,
			fileName,
		});
		return response.data.newUrl;
	},

	// Get folder size
	getFolderSize: async (orgId, path = '') => {
		try {
			// The backend expects just the orgId as the prefix or orgId/path
			// It will format it correctly on the server side
			// Try the current endpoint with the correct parameters
			try {
				// Use the folder-size endpoint with the correct query parameters
				const response = await apiClient.get(
					`/api/uploads/folder-size?orgId=${orgId}`
				);
				return response.data;
			} catch (error) {
				// If 404, try alternative endpoint or return default values
				if (error.response && error.response.status === 404) {
					console.warn(
						'Storage size endpoint not found, using default values'
					);
					// Return a default object with zero values
					return {
						bytes: 0,
						formattedSize: '0 B',
					};
				}
				throw error; // Re-throw if it's not a 404
			}
		} catch (error) {
			console.error('Error getting folder size:', error);
			throw new Error('Failed to get folder size');
		}
	},

	// List files in a folder
	listFiles: async (orgId, path = '') => {
		try {
			const response = await apiClient.get(
				`/api/uploads/${orgId}/list?path=${encodeURIComponent(path)}`
			);
			return response.data.files;
		} catch (error) {
			console.error('Error listing files:', error);
			throw new Error('Failed to list files');
		}
	},

	// Get file details
	getFileDetails: async (orgId, filePath) => {
		const response = await apiClient.get(
			`/api/uploads/${orgId}/details/${encodeURIComponent(filePath)}`
		);
		return response.data;
	},
};
